import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Patt... Remove this comment to see the full error message
import PasswordPattern from 'PatternValidationJS/patterns/Password';
import UIList from 'UIComponents/list/UIList';
import PasswordRuleValidation from './PasswordRuleValidation';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PasswordValidation = ({
  password
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    children: [/*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(UIList, {
      children: PasswordPattern.testRules(password).map(PasswordRuleValidation)
    })]
  });
};
PasswordValidation.propTypes = {
  password: PropTypes.string.isRequired
};
export default PasswordValidation;